import isBoolean from "lodash/isBoolean";
import isNumber from "lodash/isNumber";
import React from "react";

import { isPresent } from "~/tools/is-present";

import { ToggleList } from "../../../../../../components/react/_toggle-list";

const EM_DASH = "\u2014";

export interface TableRowProps {
	label: string;
}

export const TableRow: React.FC<React.PropsWithChildren<TableRowProps>> = ({ label, children }) => {
	const value = isNumber(children) || isBoolean(children) ? String(children) : children;
	const childrenCount = React.Children.toArray(value).filter(isPresent).length;

	return (
		// every TableRow should differentiate the ToggleList at least by label
		// more specific namespace can be added via ToggleList.namespace prop
		<ToggleList.Root namespace={label}>
			<div className="flex items-center break-all border-0 border-gray-200 border-t border-solid py-2 first:border-t-0">
				<div className="w-[325px] px-4">{label}</div>

				<div className="flex w-[calc(100%-325px)] flex-1 flex-wrap gap-1 px-4">
					{childrenCount ? <ToggleList.Trigger>{value}</ToggleList.Trigger> : EM_DASH}
				</div>
			</div>

			{childrenCount > 0 && <ToggleList.Content className="mb-2 ml-4 py-3 pl-4">{children}</ToggleList.Content>}
		</ToggleList.Root>
	);
};
